import '../styles/src/main.scss';

import './src/vendors/jquery.js';
import './src/vendors/jquery-ui.js';
//import './src/googleAnalyticsTracking.js';
import './src/wrapYoutubeVideos.js';
import './src/searchHandler.js';
import './src/cookieInformation.js';
import './src/postsFilter.js';
import './src/reportOrderHandler.js';
import './src/formHandler.js';
import './src/readDraftCookies.js';
import './src/global.js';
import AjaxPaginationHandler from "./src/AjaxPaginationHandler";
import SummaryPrintHelper from "./src/SummaryPrintHelper";

new AjaxPaginationHandler();
new SummaryPrintHelper().setup();
